export const getPagesCount = (length:number, itemsPerPage:number) => {
    return length % itemsPerPage === 0 ? length / itemsPerPage : Math.floor(length / itemsPerPage) + 1;
}

export const getPage = <T>(items:T[], page:number, itemsPerPage:number) => {
    let start = (page - 1)*itemsPerPage;
    let end = start + itemsPerPage;
    return items.slice(start,end);
}